import { useCallback, useState } from "react";

export default function useConfirmCallback(){

    const [confirmCB, setConfirmCB] = useState(null);

    // function to ask user if ok to proceed, then call callback with result of user choice.
    function confirmThen(callback){
        // React calls type function for lazy-set, and uses return value for value, 
        // so function to store must be wrapped in another function.
        // We have abstracted this as a function here so that it is less confusing.

        // Choice true as argument to callback means ok to discard changes, false otherwise.
        setConfirmCB(()=>callback);
    }

    // Parent component provides confirmCB via confirmThen(cb)
    // Choice true|false comes from the user via onConfirm(choice).
    const onConfirm = useCallback((choice)=>{
        try {
            confirmCB(choice);   
        } catch (error) {
            console.warn('error during useConfirmCallback callback fn', error);
        }
        setConfirmCB(null);
    }, [confirmCB]);

    return [confirmThen, confirmCB?onConfirm:null];

    // Example usage:
    // const [confirmThen, onConfirm] = useConfirmCallback();
    // ... confirmThen(choice=>{...}) ...
    // {onConfirm && <ConfirmModal message="You will lose any unsaved changes, are you sure you want to continue?" callback={onConfirm} />}
}